import axios from 'axios';
import type { BrandingConfig } from '../types/branding.types';
import { API_BASE_URL } from '@/services/api';

const DEFAULT_BRANDING: BrandingConfig = {
  organizationName: 'Atriva',
  logoUrl: '/logo-white.png',
  primaryColor: '#2053bf',
  fontFamily: 'Inter',
};

export interface FetchBrandingResult {
  branding: BrandingConfig;
  notFound: boolean;
}

function withBrandingDefaults(branding: BrandingConfig): BrandingConfig {
  return {
    ...DEFAULT_BRANDING,
    ...branding,
    logoUrl: branding.logoUrl || DEFAULT_BRANDING.logoUrl,
    primaryColor: branding.primaryColor || DEFAULT_BRANDING.primaryColor,
    fontFamily: branding.fontFamily || DEFAULT_BRANDING.fontFamily,
  };
}

export async function fetchBranding(): Promise<FetchBrandingResult> {
  try {
    const { data } = await axios.get<BrandingConfig>(`${API_BASE_URL}/branding`, {
      headers: {
        'X-Forwarded-Host': window.location.hostname,
      },
    });
    return { branding: withBrandingDefaults(data), notFound: false };
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return { branding: DEFAULT_BRANDING, notFound: true };
    }
    return { branding: DEFAULT_BRANDING, notFound: false };
  }
}

export { DEFAULT_BRANDING };
